var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SystemPage',[(_vm.content === 'login')?_c('Login'):_vm._e(),(_vm.content === 'newPassword')?_c('LoginNewPassword'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }